import React, { useEffect, useState } from "react";
import { uniqBy, orderBy, get } from "lodash";
import API from "../../utils/Api";
import Cookies from "js-cookie";
import { Notification, Breadcrumb, Table, Row, Button, Drawer } from "antd";
import { EditOutlined, EyeOutlined, DeleteOutlined } from "@ant-design/icons";
import AddBroadCast from "./addBroadCast";
import moment from "moment";

const BroadCast = () => {
  const myApi = new API({});
  myApi.createEntity({ name: "campaign" });
  myApi.createEntity({ name: "broadCast" });
  const [apiUrl] = useState(Cookies.get("apiUrl"));
  const [appKey] = useState(Cookies.get("appKey"));
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [editData, setEditData] = useState({});
  const [openDrawer, setOpenDrawer] = useState(false);
  const [selectedUserData, setSelectedUserData] = useState([]);

  const [users, setUsers] = useState([]);

  useEffect(() => {
    fetchUser();
  }, []);

  const fetchUser = () => {
    setLoading(true);
    const fields = {
      params: {
        apiUrl: apiUrl,
      },
    };
    const fieldBroadCast = {
      params: {
        campKey: appKey,
      },
    };
    Promise.all([
      myApi.endpoints.campaign.getAll(fields, {}, "get-all-user"),
      myApi.endpoints.broadCast.getAll(fieldBroadCast, {}, "get-all"),
    ])
      .then((res) => {
        const userData = uniqBy(res[0].data.userData, "phone_number");
        const orderUserData = orderBy(userData, ["user_name"], ["asc"]);
        const broadCastData = get(res[1], "data.data");
        setUsers(orderUserData);
        setData(broadCastData);
        setLoading(false);
      })
      .catch((error) => {
        Notification.error(error.message || "Failed to Fetch data");
        setLoading(false);
      });
  };
  const handleEdit = (data) => {
    setOpenModal(true);
    setEditData(data);
  };
  const handleViewUser = (data) => {
    setOpenDrawer(true);
    setSelectedUserData(data);
  };

  const handleDelete = (data) => {
    myApi.endpoints.broadCast
      .delete({ id: data.id })
      .then((res) => {
        const getData = get(res, "data");
        Notification.success({
          message: get(getData, "message", "Successfully Deleted"),
        });
        fetchUser();
      })
      .catch((error) => {
        setLoading(false);
        Notification.error({ message: error.message || "Failed to delete" });
      });
  };
  
  const columns = [
    {
      title: "BroadCast Name",
      dataIndex: "name",
      width: 200,
    },
    {
      title: "Created",
      dataIndex: "creation_date",
      width: 200,
      render: (text) => (
        <span>{moment(text).isValid() ? moment(text).format("LLL") : ""}</span>
      ),
    },
    {
      title: "Action",
      width: 200,
      render: (data) => (
        <>
          <div className="icon-space">
            {" "}
            <EditOutlined
              onClick={() => handleEdit(data)}
              style={{ color: "rgb(12, 99, 99)" }}
            />
            <DeleteOutlined
              onClick={() => handleDelete(data)}
              style={{ color: "rgb(12, 99, 99)" }}
            />
            <EyeOutlined
              onClick={() => handleViewUser(data?.user_list)}
              style={{ color: "rgb(12, 99, 99)" }}
            />
          </div>
        </>
      ),
    },
  ];
  const columnUsers = [
    {
      title: "Name",
      dataIndex: "user_name",
    },
    {
      title: "Mobile Number",
      dataIndex: "phone_number",
    },

    {
      title: "City",
      dataIndex: "city",
    },
  ];
  const handleOpenModal = () => {
    setOpenModal(true);
  };
  const handleCloseModal = () => {
    setOpenModal(false);
    setOpenDrawer(false);
    fetchUser();
    setEditData([]);
  };

  return (
    <>
      <div className="mx-2">
        <Row className="justify-bt">
          <Breadcrumb>
            <Breadcrumb.Item>BroadCast List</Breadcrumb.Item>
          </Breadcrumb>
          <Button type="primary" onClick={handleOpenModal}>
            Add New BroadCast
          </Button>
        </Row>
      </div>
      <div className="box">
        <div className="box__content p-0">
          <Table
            className="grid-table"
            loading={loading}
            columns={columns}
            dataSource={data}
          />
        </div>
      </div>
      {openModal && (
        <AddBroadCast
          users={users}
          handleCloseModal={handleCloseModal}
          openModal={openModal}
          editData={editData}
        />
      )}
      {openDrawer && (
        <Drawer
          title="User List"
          placement="right"
          onClose={handleCloseModal}
          visible={openDrawer}
          width={720}
        >
          <Table
            className="grid-table"
            columns={columnUsers}
            dataSource={selectedUserData}
          />
        </Drawer>
      )}
    </>
  );
};

export default BroadCast;
